import { Button } from 'src/components/ui/button';

export const ConfigurationSettingsAddNewPromptManually = ({
  close = () => {},
  onCreate = (() => {}) as (isManual: boolean) => void,
}) => {
  const onClick = () => {
    close();
    onCreate(true);
  };

  return (
    <div
      className={
        'flex flex-1 flex-col h-full min-w-[250px] max-w-[300px] items-center justify-between p-5 pt-8 pb-0 gap-3.5 border border-[#E3E6E8] rounded-sm-5 shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)]'
      }
    >
      <div className={'w-full flex flex-col items-center gap-2.5'}>
        <div className={'flex flex-col gap-1'}>
          <p className={'text-ebony_opacity_80 text-base font-semibold text-center'}>
            Write System Prompt Manually
          </p>
          <p className={'text-ebony_opacity_50 text-sm font-medium text-center'}>
            Create a system prompt from scratch using free-form text.
          </p>
        </div>
      </div>
      <div className={'w-full flex flex-col items-center'}>
        <Button className={'w-full'} onClick={onClick}>
          Create
        </Button>
      </div>
      <div>
        <img
          alt={'System Prompt Manually'}
          className={'w-full'}
          src={'/images/configuration/system_prompt_manual.webp'}
        />
      </div>
    </div>
  );
};
